import { useTranslation } from 'react-i18next';
import { AppShell } from '@/components/layout/AppShell';
import { PageContainer } from '@/components/layout/PageContainer';
import { TopBar } from '@/components/layout/TopBar';
import { ListItem } from '@/components/ui/ListItem';
import { useLocale } from '@/hooks/useLocale';
import type { Locale } from '@/api/types';

const LOCALES: Locale[] = ['en', 'ru', 'ar'];

export function SettingsLanguagePage(): JSX.Element {
  const { t } = useTranslation();
  const { locale, setLocale } = useLocale();
  return (
    <AppShell>
      <PageContainer>
        <TopBar back title={t('settings.language')} />
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {LOCALES.map((l) => (
            <ListItem
              key={l}
              title={t(`settings.languages.${l}`)}
              trailing={locale === l ? '✓' : ''}
              onClick={() => void setLocale(l)}
            />
          ))}
        </div>
      </PageContainer>
    </AppShell>
  );
}
